import { Component, Input, OnInit } from '@angular/core';
import { Audit } from 'app/models/entities/audit';
import { MatIconModule } from '@angular/material/icon';
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';

@Component({
    selector: 'app-audit-summary',
    templateUrl: './audit-summary.component.html',
    styleUrls: ['./audit-summary.component.scss'],
    standalone: true,
    imports: [
        MatIconModule,
        NgSwitch,
        NgSwitchCase,
        NgSwitchDefault,
    ],
})
export class AuditSummaryComponent implements OnInit
{

    @Input() audit: Audit;

    constructor() {
    }

    ngOnInit(): void {
    }

}
